export class DriverListAssignmentEntity {
  driverId?: number
  fullName?: string | null
  phoneNumber?: string | null
  userId?: string
  totalAssignment?: number
  acceptedAssignment?: number
  rejectedAssignment?: number
  ignoredAssignment?: number
}

